export function createAsyncAction(prefix) {
    return {
        REQUEST: `${prefix}_REQUEST`,
        SUCCESS: `${prefix}_SUCCESS`,
        FAIL: `${prefix}_FAIL`
    };
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/newDashBoard/utils/index.ts